import { http } from 'http-common';


class TranslationNotificationService {
  // Get list of available countries
  static async getCountries() {
    try {
      const response = await http.get(`/active-markets`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Get translation modifications based on date range and search query
  static async getTranslationModifications(params) {
    console.log('Fetching translation modifications with params:', params);
    try {
      const response = await http.get(`/translation-history`, {
        params: {
          modificationStartDate: params.modificationStartDate,
          modificationEndDate: params.modificationEndDate,
          notificationStartDate: params.notificationStartDate,
          notificationEndDate: params.notificationEndDate,
          keyword: params.keyword
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Send notifications for selected translations
  static async sendNotifications(notifications) {
    try {
      const response = await http.post('/translation-history', notifications);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Get notification status (optional - if you need to track notification status)
  static async getNotificationStatus(notificationId) {
    try {
      const response = await http.get(`/translation/notification-status/${notificationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default TranslationNotificationService;